export default __webpack_public_path__ + "static/media/party-shelby.088466bf.jpg";